export const EDITABLE_BLOT_NAME = 'editable';
